import React, { useEffect, useState } from 'react';
import {
  SettingsLayout,
  UserSettingsAuthProviders,
  UserSettingsFeatureFlags,
  UserSettingsGeneral,
} from '@backstage/plugin-user-settings';
import { DefaultGroupMembership } from './ChangeDefaultGroupMembership';
import { useUser } from '../../context/userContext';

export const SettingsPageTest = () => {
  const { getUser } = useUser();
  const [userValue, setUserValue] = useState(null);

  useEffect(() => {
    (async () => {
      const user = await getUser();
      setUserValue(user);
    })();
  }, [getUser]);

  const memberships =
    userValue !== null && userValue !== undefined
      ? userValue.groupMemberships
      : [];

  return (
    <SettingsLayout>
      <SettingsLayout.Route path="general" title="General">
        <UserSettingsGeneral />
      </SettingsLayout.Route>
      <SettingsLayout.Route
        path="auth-providers"
        title="Authentication Providers"
      >
        <UserSettingsAuthProviders />
      </SettingsLayout.Route>
      <SettingsLayout.Route path="feature-flags" title="Feature Flags">
        <UserSettingsFeatureFlags />
      </SettingsLayout.Route>
      {memberships.length !== null && memberships.length >= 2 ? (
        <SettingsLayout.Route path="default-squad" title="Default Squad">
          <DefaultGroupMembership />
        </SettingsLayout.Route>
      ) : null}
    </SettingsLayout>
  );
};
